// extracted by mini-css-extract-plugin
module.exports = {"form-box-content":"signout-form_form-box-content__3Z2Ya","redirectBackText":"signout-form_redirectBackText__CtuN5","redirect-back":"signout-form_redirect-back__SyAxH"};